import type { CSSProperties } from "react";
import { create } from "zustand";

type UiStoreState = {
    showLoader: boolean;
    setShowLoader: (showLoader: boolean) => void;
    mainMenuStyle: CSSProperties | null;
    setMainMenuStyle: (mainMenuStyle: CSSProperties | null) => void;
    mapFull: boolean;
    setMapFull: (mapFull: boolean) => void;
};

export const useUiStore = create<UiStoreState>((set) => ({
    showLoader: false,
    setShowLoader: (showLoader: boolean) => set({ showLoader }),
    mainMenuStyle: null,
    setMainMenuStyle: (mainMenuStyle: CSSProperties | null) => set({ mainMenuStyle }),
    mapFull: false,
    setMapFull: (mapFull: boolean) => set({ mapFull }),
}));
